import React from 'react'
import {
  Box,
  Container,
  Heading,
  Text,
  Button,
  Stack,
  Divider,
} from '@chakra-ui/react'
import { useHistory } from 'react-router-dom'

export function SiteDownErrorPage() {
  const history = useHistory()

  const handleGoToAccountSummary = () => {
    history.push('/details')
  }

  const handleGoBack = () => {
    history.goBack()
  }

  return (
    <Container marginInline="0" maxW="none" mt={10}>
      <Heading
        fontSize={{ base: 'lg', md: '2xl' }}
        fontWeight="medium"
        color="#003A5C"
      >
        Sorry! Looks like this part of our site is down.
      </Heading>
      <Text
        fontSize={{ base: 'md', md: 'lg' }}
        fontWeight="medium"
        color="black"
        lineHeight="1.6"
        mb={6}
      >
        We're sorry for the inconvenience while we work on getting this part of
        the site back and running. To make a payment, call us at{' '}
        <Text
          as="a"
          href="tel:8339071737"
          color="blue.500"
          textDecoration="underline"
        >
          (833) 907-1737
        </Text>
        . If you have any questions visit your local branch or call us
      </Text>
      <Text fontSize="sm" color="gray.500" mt={6} fontStyle="italic">
        Republic Finance, LLC branch locations do not accept cash payments. You
        must use an approved VanillaDirect Pay location in order to make cash
        payments on your loan.
      </Text>
      <Divider />
      <Stack
        direction={{ base: 'column', md: 'row' }}
        spacing={4}
        align={{ base: 'stretch', md: 'flex-start' }}
      >
        <Button
          colorScheme="blue"
          onClick={handleGoToAccountSummary}
          w={{ base: '100%', md: 'auto' }}
          h={{ base: '40px', md: '50px' }}
          borderColor="#2371A5"
          fontSize="1rem"
        >
          Go to Account Summary
        </Button>
        <Button
          variant="outline"
          onClick={handleGoBack}
          w={{ base: '100%', md: 'auto' }}
          h={{ base: '40px', md: '50px' }}
        >
          Go Back
        </Button>
      </Stack>
    </Container>
  )
}
